/** @format */
import {AccountsHotspotsStateInput} from 'graphql/generated/types';

import {HotspotKey} from '../types';

const getMutationKey = (key: HotspotKey): keyof AccountsHotspotsStateInput | null => {
  switch (key) {
    case 'mediaplan':
      return 'mediaplanHideAt';
    case 'sensors':
      return 'sensorsHideAt';
    case 'feeds':
      return 'feedHideAt';
    case 'funnel':
      return 'funnelHideAt';
    default:
      return null;
  }
};

export {getMutationKey};
